export default "skymp5-front/979f8c0fd92d8f17a7f0df73c3ca3bd2.png";